import React, { useState, useCallback, useEffect } from 'react';
import { supabase } from '../../../supabaseClient';
import { useAdmin } from '../../../context/AdminContext';

const ScrimmagesPanel = () => {
    const { adminId, activeSeason } = useAdmin();
    const [scrimmages, setScrimmages] = useState([]);
    const [loading,    setLoading]    = useState(false);

    const loadScrimmages = useCallback(async () => {
        if (!activeSeason) return;
        setLoading(true);
        const { data } = await supabase
            .from('games')
            .select('*, team1:teams!games_team1_id_fkey(name), team2:teams!games_team2_id_fkey(name)')
            .eq('game_type', 'scrimmage')
            .eq('season_id', activeSeason.id)
            .order('game_date', { ascending: false });
        setScrimmages(data || []);
        setLoading(false);
    }, [activeSeason]);

    useEffect(() => { loadScrimmages(); }, [loadScrimmages]);

    const handleDelete = async (gameId) => {
        if (!window.confirm('Delete this scrimmage and all its stats?')) return;
        await supabase.functions.invoke('admin-actions', {
            body: { action: 'deleteScrimmage', adminId, payload: { gameId } },
        });
        loadScrimmages();
    };

    // Parse without UTC shift
    const formatDate = (str) => {
        const [date, time = '00:00'] = (str || '').split('T');
        const [y, m, d]              = date.split('-').map(Number);
        const [hh, mm]               = time.split(':').map(Number);
        return new Date(y, m - 1, d, hh, mm).toLocaleString('en-US', {
            month: 'short', day: 'numeric', year: 'numeric',
            hour: 'numeric', minute: '2-digit',
        });
    };

    return (
        <div className="space-y-4">
            <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Scrimmages</h2>

            {loading ? (
                <p className="text-gray-500 dark:text-gray-400 text-center py-8">Loading…</p>
            ) : scrimmages.length === 0 ? (
                <p className="text-gray-500 dark:text-gray-400 text-center py-8">No scrimmages recorded.</p>
            ) : (
                scrimmages.map(game => (
                    <div key={game.id} className="border dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-gray-700/50">
                        <div className="flex justify-between items-center">
                            <div>
                                <h3 className="text-xl font-bold text-orange-600 dark:text-orange-400">
                                    {game.team1?.name} vs {game.team2?.name}
                                </h3>
                                <p className="text-gray-600 dark:text-gray-400 text-sm">{formatDate(game.game_date)}</p>
                            </div>
                            <button
                                onClick={() => handleDelete(game.id)}
                                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                            >
                                Delete Scrimmage
                            </button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default ScrimmagesPanel;